import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Typography,
  Chip,
  CircularProgress,
  Skeleton,
} from '@mui/material';
import { getStatusColor } from '../utils';

const AssignedUsersDialog = ({
  open,
  assignedUsers,
  assignedUsersLoading,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Assigned Users History {assignedUsersLoading && <CircularProgress size={20} sx={{ ml: 1 }} />}
      </DialogTitle>
      <DialogContent dividers>
        {assignedUsersLoading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {[...Array(3)].map((_, i) => <Skeleton key={i} height={60} />)}
          </Box>
        ) : assignedUsers.length === 0 ? (
          <Typography align="center" sx={{ py: 3 }} color="text.secondary">
            No assignment history
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>User</strong></TableCell>
                  <TableCell><strong>Status</strong></TableCell>
                  <TableCell><strong>Remarks</strong></TableCell>
                  {/* <TableCell><strong>Date</strong></TableCell> */}
                  <TableCell><strong>Created At</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assignedUsers.map((log) => (
                  <TableRow key={`${log?.id}`} hover>
                    {/* User name – only show on first activity row */}
                    <TableCell

                      style={{
                        verticalAlign: 'top',
                        // display: log?.id === 0 ? 'table-cell' : 'none'
                      }}
                    >
                      <Typography variant="body2">
                        {log.assignee?.name || '—'}
                      </Typography>
                    </TableCell>

                    {/* Status */}
                    <TableCell>
                      <Chip
                        label={log.status?.name || '—'}
                        size="small"
                        color={getStatusColor(log.status?.name)} // use activity.status
                      />
                    </TableCell>

                    {/* Remarks */}
                    <TableCell>
                      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                        {log.description || '—'}
                      </Typography>
                    </TableCell>

                    {/* Date */}
                    {/* <TableCell>
                          {log.created_at ? new Date(log.created_at).toLocaleString() : '—'}
                        </TableCell> */}
                    <TableCell>
                      {log.created_at ? new Date(log.created_at).toLocaleString() : '—'}
                    </TableCell>
                  </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignedUsersDialog;